export default __webpack_public_path__ + "static/media/saunatimeTwitter-600x314.4d52d407.jpg";